import { Component, computed, input, InputSignal, Signal } from '@angular/core';

import { FooterContact } from '@core/layout/footer/footer-contact/footer-contact';
import { FooterCopyright } from '@core/layout/footer/footer-copyright/footer-copyright';
import { FooterLinksColumn } from '@core/layout/footer/footer-links-column/footer-links-column';
import { FooterSocials } from '@core/layout/footer/footer-socials/footer-socials';
import { CmsStyles } from '@shared/directives/cms-styles/cms-styles.directive';
import {
    ContactInfoBlock,
    CopyrightBlock,
    FooterLinks,
    LandingFooter,
    SocialItem,
} from '@core/cms/landing.cms';

@Component({
    selector: 'app-footer',
    imports: [FooterLinksColumn, FooterContact, FooterCopyright, FooterSocials, CmsStyles],
    templateUrl: './footer.html',
    styleUrl: './footer.scss',
})
export class Footer {
    /** CMS-provided footer content (link columns, contact info, copyright). */
    public readonly footer: InputSignal<LandingFooter | null | undefined> = input<
        LandingFooter | null | undefined
    >();

    /** Link columns, sourced from the CMS. */
    protected readonly linksList: Signal<ReadonlyArray<FooterLinks>> = computed(
        (): ReadonlyArray<FooterLinks> => this.footer()?.linksList ?? [],
    );

    /** Contact column (logo, address and contact links). */
    protected readonly contactInfo: Signal<ContactInfoBlock | null | undefined> = computed(
        (): ContactInfoBlock | null | undefined => this.footer()?.contactInfo,
    );

    /** Copyright bar (notice plus an optional row of social links). */
    protected readonly copyrightBlock: Signal<CopyrightBlock | null | undefined> = computed(
        (): CopyrightBlock | null | undefined => this.footer()?.copyrightBlock,
    );

    /** Social links, or empty when the CMS switches the row off via `socialLinksEnabled`. */
    protected readonly socialItems: Signal<ReadonlyArray<SocialItem>> = computed(
        (): ReadonlyArray<SocialItem> => {
            const block: CopyrightBlock | null | undefined = this.copyrightBlock();

            return block?.socialLinksEnabled ? (block.socialItems ?? []) : [];
        },
    );
}
